import axios from "axios";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import "./index.css";

const MultiPayment = () => {
  const [searchParams] = useSearchParams();
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    payNow();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [searchParams]);


  const PhonePePayment = async () => {
    const data = {
      name: searchParams.get("name"),
      mobileNumber: searchParams.get("mobileno"),
      amount: searchParams.get("amount"),
      domainname: window.location.hostname,
    };

    try {
      setLoading(true);
      const res = await axios.post(
        `${process.env.REACT_APP_PAYMENT_NODE_URL}/api/phonepay/sdk/create-order`,
        data
      );

      if (res.data?.data?.instrumentResponse?.redirectInfo?.url) {
        window.open(res.data.data.instrumentResponse.redirectInfo.url, "_self");
      }
    } catch (error) {
      console.error("Error in payment:", error);
    } finally {
      setTimeout(() => {
        setLoading(false);
      }, 2000);
    }
  };

  const payNow = async () => {
    if (process.env.REACT_APP_PAYMENT_TYPE === "phonepe") {
      PhonePePayment();
    } else {
      setLoading(true);
    }
  };

  return (
    <>
      {loading && (
        <div
          style={{
            width: "100%",
            height: "100vh",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            flexDirection: "column",
          }}
        >
          <Spinner />
          <div>Please wait</div>
        </div>
      )}
    </>
  );
};

export default MultiPayment;
